import { render } from "./ClassEntryForm.vue?vue&type=template&id=528c8744"
import script from "./ClassEntryForm.vue?vue&type=script&lang=js"
export * from "./ClassEntryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__